var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"booking-layout"},[_c('BookingBreadcrumb'),_c('b-container',[_c('b-row',{staticClass:"row-eq-height"},[_c('b-col',{attrs:{"col":"","lg":"4","md":"4","sm":"12","cols":"12"}},[_c('BookingForm')],1),_c('b-col',{attrs:{"col":"","lg":"8","md":"8","sm":"12","cols":"12"}},[_c('BookingResult')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }